import React from 'react'

const React_Coding_Practice_33 = () => {
  return (
    <div>
      <h1>Coding Pratice 33</h1>
    </div>
  )
}

export default React_Coding_Practice_33
